import styled from 'styled-components'
import React from 'react'
import { Box, Image, Text } from '../../designSystem'
import EmptyNovel from '../../components/Images/EmptyNovel'
const emptyContainer = {
    display:'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
    p: 16,
    maxWidth: ['100vw','60vw']
}
const header = {
  fontSize: ['M.L','D.L'],
  fontWeight: 's',
  lineHeight: '1.2',
  color: 'text.text700',
  textTransform: 'captilize',
  textAlign:'center',
  pt: 32
}
const subHeader = {
  ...header,
  fontSize: 'D.S',
  fontWeight: 'r',
  color: 'text.text500',
  pt: 16
}


export default function EmptyState({text,subText,image = EmptyNovel,...props}) {
  const Icon = styled(image)`
  margin-top: 5%;
  width: 160px;
  height: 160px;
  `
  return (
    <Box {...emptyContainer}>
       <Icon />
       <Text {...header}>{text}</Text>
       <Text {...subHeader}>{subText}</Text>
    </Box>
  )
}
